export const parseScopes = (rawScopes) =>
  rawScopes
    .split(",")
    .map((scope) => scope.trim())
    .filter(Boolean);

export const stripTrailingSlashes = (value) => {
  let normalizedValue = value;

  while (normalizedValue.endsWith("/")) {
    normalizedValue = normalizedValue.slice(0, -1);
  }

  return normalizedValue;
};

export const removeSuffix = (value, suffix) =>
  value.endsWith(suffix) ? value.slice(0, -suffix.length) : value;

export const normalizeBackendSpecUrl = (value) =>
  [
    "/v1/spec-review",
    "/v1/spec-fix",
    "/v1/spec-generate",
    "/spec-review",
    "/spec-fix",
    "/spec-generate",
    "/v1",
  ].reduce(
    (normalizedValue, suffix) => removeSuffix(normalizedValue, suffix),
    stripTrailingSlashes(String(value || "").trim())
  );

const defaultBackendSpecUrl =
  "https://api-governance-dev.fceks-useast1-1.int.platform.security.cisco.com";
const defaultOktaIssuer = "https://sso-preview.test.security.cisco.com/oauth2/ausrbsiz6hbu5Dt6l0h7";
const defaultOktaClientId = "0oa2pdpz65badlOa20h8";
const backendSpecUrl = normalizeBackendSpecUrl(
  process.env.BACKEND_SPEC_URL ||
    process.env.SPEC_REVIEW_URL ||
    process.env.SPEC_GENERATE_URL ||
    defaultBackendSpecUrl
);

export const appConfig = {
  oktaIssuer: process.env.REACT_APP_OKTA_ISSUER || defaultOktaIssuer,
  oktaClientId: process.env.REACT_APP_OKTA_CLIENT_ID || defaultOktaClientId,
  oktaScopes: parseScopes(process.env.REACT_APP_OKTA_SCOPES || "openid,profile,email"),
  oktaLoginCallbackPath: "/login/callback",
  oktaLogoutCallbackPath: "/logout/callback",
  backendSpecUrl,
  specReviewUrl: `${backendSpecUrl}/v1/spec-review`,
  specFixUrl: `${backendSpecUrl}/v1/spec-fix`,
  specGenerateUrl: `${backendSpecUrl}/v1/spec-generate`,
  createServicePrUrl: `${backendSpecUrl}/v1/create-service-pr`,
  createJiraUrl: `${backendSpecUrl}/v1/create-jira`,
};

export const isOktaConfigured = Boolean(appConfig.oktaIssuer && appConfig.oktaClientId);
